<template>
    <button @click="onClickBack" class="close modal-back">
        <a-icon icon="ArrowLeft" />
    </button>
</template>

<script>
export default {
    props: {
        confirmation: {
            type: Object,
            default: null
        },
        onClickBack: {
            type: Function,
            default: () => {}
        }
    }
}
</script>
